function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoach1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    style: {
      fill: "rgb(255,0,0)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach1);
export default __webpack_public_path__ + "static/media/coach1.d5ea5cc3c82f63acaaf62e68b22b29ff.svg";
export { ForwardRef as ReactComponent };